import {
  Box,
  FormControl,
  FormLabel,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material';
import type { AzureDisk } from '@repo/api-gw-sdk';

import { fileSizeFormatter } from '@/utils/fileSizeFormatter';

import { TransactionalTextField } from '../shared/transactionalTextField';

interface Props {
  accountId: string;
  location?: string;
  initialSettings?: AzureDisk;
  settings?: AzureDisk;
  onChange: (settings: AzureDisk) => void;
  keepOriginalSettings?: boolean;
  setKeepOriginalSettings: (value: boolean) => void;
}

export const DiskSettingsSection = ({
  initialSettings,
  settings: _settings,
  keepOriginalSettings,
  onChange,
  setKeepOriginalSettings,
}: Props) => {
  // const dal = useDAL();
  // const { body } = dal.restore.azureRestoreConfig.listSKUs(accountId, location ?? '','disks');

  const settings = _settings || initialSettings;
  // const uniqueNames = Array.from(
  //   new Set((body?.skus || []).map((x) => x.name))
  // ).sort();

  return (
    <Box className='mx-[40px] my-[24px]'>
      <Box className='flex justify-between items-center'>
        <Typography className='font-semibold' variant='body1'>
          Keep original settings
        </Typography>
        <Switch
          size='small'
          checked={keepOriginalSettings}
          onChange={() => {
            setKeepOriginalSettings(!keepOriginalSettings);
          }}
        />
      </Box>
      {keepOriginalSettings && (
        <Box className='mt-[10px]'>
          <Table size='small'>
            <TableBody>
              <TableRow>
                <TableCell className='border-0 px-0'>Name</TableCell>
                <TableCell className='border-0 px-0'>
                  {initialSettings?.settings.name}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className='border-0 px-0'>Type</TableCell>
                <TableCell className='border-0 px-0'>
                  {initialSettings?.settings.type}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className='border-0 px-0'>Tier</TableCell>
                <TableCell className='border-0 px-0'>
                  {initialSettings?.settings.tier}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className='border-0 px-0'>Size</TableCell>
                <TableCell className='border-0 px-0'>
                  {fileSizeFormatter(
                    initialSettings?.settings.sizeBytes,
                    1,
                    false
                  )}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className='border-0 px-0'>
                  Hyper-V Generation
                </TableCell>
                <TableCell className='border-0 px-0'>
                  {initialSettings?.settings.hyperVGeneration}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Box>
      )}
      {!keepOriginalSettings && (
        <Box className='mt-[20px] w-1/2 pr-[18px]'>
          <FormControl size='small' className='w-full mb-[24px]'>
            <FormLabel>Disk Name*</FormLabel>
            <TransactionalTextField
              initValue={settings?.settings.name ?? ''}
              onChange={(diskName) =>
                onChange({
                  ...settings!,
                  settings: {
                    ...settings!.settings,
                    name: diskName,
                  },
                })
              }
            />
          </FormControl>
          {/* <FormControl size='small' className='w-full mb-[24px]'>
            <FormLabel>Type</FormLabel>
            <Select value={settings?.diskType || ''} onChange={() => {}}>
              {uniqueNames.map((sku) => (
                <MenuItem key={sku} value={sku}>
                  {sku}
                </MenuItem>
              ))}
            </Select>
          </FormControl> */}
        </Box>
      )}
    </Box>
  );
};
